import AttendanceVM from './attendance-vm';

export default {
  init(element) {
    //
    // Following options explained here:
    // https://github.com/Knockout-Contrib/Knockout-Validation/wiki/Configuration
    //
    const validationOptions = {
      insertMessages: false,
      errorsAsTitle: true,
      decorateInputElement: true,
      parseInputAttributes: true,
      messagesOnModified: true,
      errorElementClass: 'error',
      errorMessageClass: 'error',
      decorateElementOnModified: true,
      decorateElement: true,
    }

    const course_attendance_data = JSON.parse($('#course_attendance_json').val())

    ko.applyBindingsWithValidation(
      new AttendanceVM(course_attendance_data),
      document.getElementById('course_participation'),
      validationOptions
    )
  }
}
